import { ApiError, NetworkError } from '../api/client'

/**
 * Was ein fehlgeschlagener Abruf bedeutet.
 *
 * Stand woertlich in `useListQuery` und wird von `useEndlessList` genauso
 * gebraucht. Zweimal geschrieben waere es zweimal zu korrigieren, wenn ein
 * Fall dazukommt — dieselbe Ueberlegung, aus der `useListQuery` ueberhaupt
 * entstanden ist.
 *
 * `denied` steht getrennt vom Fehlertext, weil die Ansicht darauf anders
 * antwortet: Ein 403 zeigt den Rechtehinweis, alles andere eine Fehlerbox.
 */
export interface Fehlerdeutung {
  denied: boolean
  message: string | null
}

export function deuteFehler(cause: unknown): Fehlerdeutung {
  if (cause instanceof ApiError && cause.status === 403) {
    // Der verbindliche Fall. Er kann auch eintreten, wenn die Rechte
    // geaendert wurden, waehrend jemand angemeldet war — davon weiss die
    // Pruefung aus der Sitzung nichts.
    return { denied: true, message: null }
  }
  if (cause instanceof NetworkError) {
    return { denied: false, message: 'Der Server ist nicht erreichbar.' }
  }
  if (cause instanceof ApiError) {
    return { denied: false, message: cause.message }
  }
  return { denied: false, message: String(cause) }
}
